<footer class="footer">

  <div class="footer__menu">

    <div>
      <img class="footer__logo" src="../../../assets/images/logo-main.svg?v={{logoVersionNumber()}}"
        alt="Pet Wants - Logo" />
    </div>

    @for (item of menu(); track $index) {
    @if ((item.hideWithSession && !hasSession()) || !item.hideWithSession) {
    <nav>
      <header class="footer__title" (click)="goTo(item)">
        {{item.title}}
      </header>
      @if (item.items?.length) {
      <ul class="footer__list mb-4 mb-md-0">
        @for (submenu of item.items; track $index) {
        @if ((item.hideWithSession && !hasSession()) || !item.hideWithSession) {
        <li>
          <a href="javascript:void(0)" (click)="goTo(submenu)">
            {{submenu.title}}
          </a>
        </li>
        }
        }
      </ul>
      }
    </nav>
    }
    }

    <div class="to-top" (click)="scrollToLink('scroll-to-top-ref')">
      <i class="icon fa-solid fa-chevron-up"></i>
      <div class="text">To top</div>
    </div>

  </div>

  <div class="footer__social">

    <span class="h7-regular">
      Pet Wants Cincy © {{copyRightYear}}
    </span>

    <div class="icons">

      <a href="https://www.facebook.com/petwantscincy" title="Facebook" target="_blank" rel="noopener">
        <svg width="25" height="25" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20 10.6826C20 5.16262 15.52 0.682617 10 0.682617C4.48 0.682617 0 5.16262 0 10.6826C0 15.5226 3.44 19.5526 8 20.4826V13.6826H6V10.6826H8V8.18262C8 6.25262 9.57 4.68262 11.5 4.68262H14V7.68262H12C11.45 7.68262 11 8.13262 11 8.68262V10.6826H14V13.6826H11V20.6326C16.05 20.1326 20 15.8726 20 10.6826Z"
            fill="#50391d" />
        </svg>
      </a>

      <a href="https://www.instagram.com/petwantscincy/" title="Instagram" target="_blank" rel="noopener">
        <svg width="25" height="25" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M20.1962 4.10377C20.4923 4.88964 20.6495 5.72105 20.6607 6.56081C20.7225 7.61705 20.7228 7.96246 20.725 10.6362L20.725 10.6732C20.725 13.382 20.7106 13.7201 20.6629 14.7868C20.6463 15.6172 20.49 16.4355 20.1984 17.2117C19.9412 17.8744 19.5488 18.4762 19.0462 18.9789C18.5435 19.4815 17.9417 19.8739 17.279 20.1311C16.5032 20.4222 15.6836 20.5793 14.8552 20.5956C13.7963 20.6577 13.4493 20.6577 10.7417 20.6577C8.03405 20.6577 7.69588 20.6433 6.62813 20.5956C5.79808 20.5683 4.97876 20.3996 4.20547 20.0967C3.54249 19.8401 2.94033 19.448 2.43746 18.9455C1.93459 18.443 1.54207 17.8412 1.28497 17.1784C0.99336 16.4011 0.837023 15.5829 0.820392 14.7535C0.758301 13.6935 0.758301 13.3476 0.758301 10.64C0.758301 7.93236 0.772715 7.59418 0.820392 6.52644C0.836051 5.69831 0.993173 4.87895 1.28497 4.10377C1.54164 3.44079 1.93387 2.83869 2.43657 2.33599C2.93928 1.83328 3.54138 1.44105 4.20436 1.18438C4.97978 0.893293 5.79895 0.735832 6.62702 0.718697C7.6859 0.657715 8.03294 0.657715 10.7406 0.657715C13.4482 0.657715 13.7864 0.67102 14.853 0.718697C15.6814 0.735707 16.501 0.89317 17.2768 1.18438C17.9396 1.44123 18.5417 1.83352 19.0443 2.33621C19.547 2.83889 19.9393 3.4409 20.1962 4.10377ZM5.60806 10.6344C5.60806 13.4662 7.90211 15.7603 10.7339 15.7603C12.0934 15.7603 13.3971 15.2202 14.3584 14.259C15.3197 13.2977 15.8598 11.9939 15.8598 10.6344C15.8598 9.27497 15.3197 7.97119 14.3584 7.00991C13.3971 6.04863 12.0934 5.50859 10.7339 5.50859C7.90211 5.50859 5.60806 7.80263 5.60806 10.6344ZM15.6062 6.42355C15.7513 6.48357 15.9068 6.51439 16.0638 6.51424C16.7235 6.51424 17.2579 5.97981 17.2579 5.31899C17.2579 5.1621 17.227 5.00674 17.167 4.86179C17.1069 4.71685 17.0189 4.58514 16.908 4.47421C16.7971 4.36327 16.6654 4.27527 16.5204 4.21523C16.3755 4.15519 16.2201 4.12429 16.0632 4.12429C15.9063 4.12429 15.751 4.15519 15.606 4.21523C15.4611 4.27527 15.3294 4.36327 15.2184 4.47421C15.1075 4.58514 15.0195 4.71685 14.9595 4.86179C14.8994 5.00674 14.8685 5.1621 14.8685 5.31899C14.8684 5.47599 14.8992 5.63148 14.9592 5.77656C15.0192 5.92164 15.1073 6.05347 15.2183 6.16448C15.3293 6.2755 15.4611 6.36354 15.6062 6.42355ZM14.0636 10.6344C14.0636 12.4733 12.5728 13.9641 10.7339 13.9641C8.89502 13.9641 7.40429 12.4733 7.40429 10.6344C7.40429 8.79552 8.89502 7.30479 10.7339 7.30479C12.5728 7.30479 14.0636 8.79552 14.0636 10.6344Z"
            fill="#50391d" />
        </svg>
      </a>

    </div>

  </div>
</footer>